import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ImageModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ImageMagnifierZoom from "@tSurya/Components/ImageMagnifierZoom";
import ImageMagnifier from "@tSurya/Components/Imagemagnifire";
import ImageMagnifyZoom from "@tSurya/Components/ImageMagnifyZoom";
import ProductPrimaryImage from "@tSurya/Overrides/Components/ProductPrimaryImage";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    product: ProductModel;
    image: ImageModel;
    useLargeImage?: boolean;
    onClick?: () => void;
    extendedStyles?: ProductPrimaryImageStyles;
    zoomType: string;
    zoomLevel: number;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

export interface ProductPrimaryImageStyles {
    centeringWrapper?: InjectableCss;
    /**
     * @deprecated Not used anymore
     */
    hiddenWrapper?: InjectableCss;
    /**
     * @deprecated Not used anymore
     */
    spinner?: LoadingSpinnerProps;
    /**
     * @deprecated Use img instead
     */
    image?: LazyImageProps;
    img?: ImgProps;
    iframeContainer?: InjectableCss;
}

export const productPrimaryImageStyles: ProductPrimaryImageStyles = {
    centeringWrapper: {
        css: css`
            min-height: 300px;
            margin: 0 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${getColor("common.backgroundContrast")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-height: 392px;
                    `,
                    css`
                        max-height: 392px;
                    `,
                    css`
                        max-height: 392px;
                    `,
                    null,
                    null,
                ])}
            img {
                &.smallImage {
                    height: 100vh !important;
                    max-height: 610px;
                }

                /* height: 100vh !important;
                max-height: 610px; */
                /* width: 100% !important; */
                // max-width: 100%;
                // mix-blend-mode: multiply;
            }
        `,
    },
    image: {
        css: css`
            margin: auto;
            cursor: pointer;
        `,
    },
    img: {
        css: css`
            cursor: pointer;
        `,
    },
    iframeContainer: {
        css: css`
            width: 700px;
            max-width: 100%;
            iframe {
                border-width: 0px !important;
                display: none;
            }
        `,
    },
};

const ProductCustomPrimaryImage = ({
    productSettings,
    product,
    image,
    useLargeImage,
    onClick,
    extendedStyles,
    zoomType,
    zoomLevel,
}: Props) => {
    const [styles] = useState(() => mergeToNew(productPrimaryImageStyles, extendedStyles));
    const [isTabView, setIsTabView] = useState(false);
    // const videoRegex = /^[0-9]{1,2}\.(?:mp4|mpg|avi)$/;

    // const viemoRegex =
    /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i;
    const youtubeRegex = /^[a-zA-Z0-9_-]{11}$/;

    if (!product) {
        return null;
    }

    useEffect(() => {
        if ((window as any).sirvScriptAdded) {
            return;
        }

        if (
            productSettings.imageProvider !== "SIRV" ||
            !product.images ||
            product.images.every(o => o.imageType !== "360")
        ) {
            return;
        }

        const script = document.createElement("script");
        script.src = "https://scripts.sirv.com/sirv.js";
        script.async = true;

        document.body.appendChild(script);
        (window as any).sirvScriptAdded = true;
    }, [productSettings.imageProvider, product]);

    const imageWrapperClickHandler = () => {
        onClick?.();
    };

    const imageWrapperKeyHandler: React.KeyboardEventHandler<HTMLImageElement> = event => {
        event.preventDefault();
        event.stopPropagation();
        if (event.key === "Enter") {
            onClick?.();
        }
    };
    React.useEffect(() => {
        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, []);
    const onWindowResize = () => {
        if (window.innerWidth >= 991) {
            setIsTabView(false);
        } else {
            setIsTabView(true);
        }
    };
    const path = useLargeImage
        ? image.largeImagePath || image.mediumImagePath
        : image.mediumImagePath || image.largeImagePath;
    if (!path) {
        return null;
    }

    return (
        <>
            {image.imageType === "Static" && (
                <StyledWrapper {...styles.centeringWrapper} onClick={imageWrapperClickHandler}>
                    {youtubeRegex.test(path) && (
                        <StyledWrapper {...styles.iframeContainer}>
                            <iframe
                                src={`https://www.youtube.com/embed/${path}`}
                                width="100%"
                                height="550px"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            ></iframe>
                        </StyledWrapper>
                    )}
                    {isTabView && (
                        <ProductPrimaryImage
                            product={product}
                            image={image}
                            // extendedStyles={styles.fullPrimaryImage}
                        />
                    )}
                    {/* {!isTabView && (
                        <ImageMagnifier src={path} width="600" height="600" zoomLevel={zoomLevel} zoomType={zoomType} />
                    )} */}
                    {/* {!isTabView && <ImageMagnifierZoom imagePath={path} zoomLevel={zoomLevel} />} */}
                    {!isTabView && (
                        <ImageMagnifyZoom
                            imagePath={path}
                            imageAlt={image.imageAltText}
                            largeImagePath={image.largeImagePath ? image.largeImagePath : image.mediumImagePath}
                        />
                    )}
                </StyledWrapper>
            )}
            {image.imageType === "360" && productSettings.imageProvider === "SIRV" && (
                <div style={{ minHeight: 300 }} onClick={imageWrapperClickHandler}>
                    <div className="Sirv" key={image.id} data-src={image.mediumImagePath} />
                </div>
            )}
        </>
    );
};

export default connect(mapStateToProps)(ProductCustomPrimaryImage);
